exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cUjYpQHb2tkqSoDUPW1b-{overflow:hidden;white-space:nowrap;text-overflow:ellipsis}html[dir] .cUjYpQHb2tkqSoDUPW1b-{padding-bottom:10px}", ""]);

// exports
exports.locals = {
	"checkbox": "cUjYpQHb2tkqSoDUPW1b-"
};